import Vue from 'vue';
import Vuex from 'vuex';
import createCache from 'vuex-cache';

Vue.use(Vuex);

import menu from './modules/menu';
import orders from './modules/orders';
import location from './modules/location';
import login from './modules/auth';
import generic from './modules/generic';
import partners from './modules/partners';
import payment from './modules/accounts/payments/payment';
import payments from './modules/accounts/payments/payments';
import contracts from './modules/purchases/contracts/purchaseContracts';
import lots from './modules/purchases/lots/purchaseLots';
import purchaseOrders from './modules/purchases/orders/purchaseOrders';
import requests from './modules/purchases/requests/requests';
import woodware from './modules/woodware';
import accounting from './modules/accounting';
import salesContracts from './modules/sales/contracts/salesContracts';
import salesContract from './modules/sales/contracts/salesContract';
import generalPartners from './modules/general/partners/generalPartners';
import generalPartner from './modules/general/partners/generalPartner';
import products from './modules/general/products/products';
import pricePolicy from './modules/general/pricePolicy';
import generalDocuments from './modules/general/documents/generalDocuments';
import packagesBinding from './modules/purchases/binding/packagesBinding';
import purchaseOrderItems from './modules/purchases/order-items/purchaseOrderItems';
import salesOrders from './modules/sales/orders/salesOrders';
import salesOrder from './modules/sales/orders/salesOrder';
import operations from './modules/manufacture/operations/operations';
import operation from './modules/manufacture/operations/operation';
import packets from './modules/manufacture/packets/packets';
import rawDistribution from './modules/production-planning/raw-distribution/rawDistribution';
import salesAgentsInvoices from './modules/agents/sales-invoices/salesAgentsInvoices';
import salesAgentsInvoice from './modules/agents/sales-invoices/salesAgentsInvoice';
import priceLists from './modules/purchases/priceLists'
import invoicesApproval from './modules/sales/invoices-approval/invoicesApproval'

export const store = new Vuex.Store({
  modules: {
    menu,
    orders,
    login,
    location,
    generic,
    partners,
    payment,
    payments,
    contracts,
    lots,
    purchaseOrders,
    requests,
    woodware,
    salesContracts,
    salesContract,
    generalPartners,
    generalPartner,
    products,
    pricePolicy,
    packagesBinding,
    purchaseOrderItems,
    salesOrders,
    salesOrder,
    operations,
    operation,
    packets,
    rawDistribution,
    salesAgentsInvoices,
    salesAgentsInvoice,
    accounting,
    generalDocuments,
    priceLists,
    invoicesApproval
  },
  plugins: [createCache()]
  //strict: process.env.NODE_ENV !== 'production'
});




// WEBPACK FOOTER //
// ./src/store/index.js